module.exports = __webpack_public_path__ + "static/media/bar_chart.63235a2d.svg";